import { Check, X } from "lucide-react";
import "./ProductComments.css";
export default function CommentCard({ comment }) {

    return (

        <div className="comment-card">

            <div className="header">
                <div className="avatar">
                    <img src="/images/icons/avatar.png" />
                </div>
                <div className="info">
                    <p> {comment.user}  </p>
                    <p className="CommentsStyle2">{comment.created_at} </p>
                </div>
            </div>
            <div className="comment-list">
                <div className="comment-text">
                    <p className="CommentsStyle1">
                        {comment.comment}
                    </p>
                </div>
                {comment.reply && (
                    <div className="replay-comment-list pr-3">
                        <div className="comment-box">
                            <div className="header">

                                <div className="avatar">
                                    <img src="/images/icons/logo.png" alt=" کافه دارو " />
                                </div>
                                <div className="info p-3 m-0">
                                    <span>  کافه دارو -دکتر داروساز</span>
                                </div>

                            </div>

                            <div className="inner">
                                <div className="p-2 text-justify">
                                    {/* <p>{comment.reply}</p> */}


                                    <div
                                        className="product-html"
                                        dangerouslySetInnerHTML={{
                                            __html: comment.reply
                                        }}
                                    />


                                </div>
                            </div>

                        </div>
                    </div>
                )}
            </div>

            <div className="stars">

                {"★".repeat(comment.rate)}

            </div>


        </div>



    )

}